import { Cookies } from 'react-cookie';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';
import {
    PAGE_FAILED,
    PAGE_DOWNLOADED,
    PAGE_DELETED,
    PAGE_DELETING,
    PAGE_EDITING,
    PAGE_POSTING,
    PAGE_RESET,
    PAGES_PENDING,
    PAGES_DOWNLOADED,
    PAGES_RESET,
    PAGES_FAILED,
    PAGE_FOCUS,
    PAGE_MEDIA_UPLOADING,
    PAGE_MEDIA_UPLOADED,
    PAGE_MEDIA_FOCUS,
    PAGE_MEDIA_FAILED,
    PAGE_MEDIA_DELETING,
    PAGE_MEDIA_DELETED,
} from './types';

const cookies = new Cookies();

export const pagesResetAction = () => {
    return {
        type: PAGES_RESET,
    };
};

export const pageResetAction = () => {
    return {
        type: PAGE_RESET,
    };
};

export const pagesPendingAction = () => {
    return {
        type: PAGES_PENDING,
    };
};

export const postPageAction = () => {
    return {
        type: PAGE_POSTING,
    };
};

export const pageEditingAction = () => {
    return {
        type: PAGE_EDITING,
    };
};

export const pagesDownloadedAction = (pages, lang) => {
    return {
        type: PAGES_DOWNLOADED,
        payload: {
            lang: lang,
            pages: pages,
        },
    };
};

export const pageDownloadedAction = (page, lang) => {
    return {
        type: PAGE_DOWNLOADED,
        payload: {
            lang: lang,
            page: page,
        },
    };
};

export const deletePageAction = () => {
    return {
        type: PAGE_DELETING,
    };
};

export const pageDeletedAction = (id, lang) => {
    return {
        type: PAGE_DELETED,
        payload: {
            id: id,
            lang: lang,
        },
    };
};

export const pageFocusAction = (page, lang) => {
    return {
        type: PAGE_FOCUS,
        payload: {
            page: page,
            lang: lang,
        },
    };
};

export const pageMediaFocusAction = (media) => {
    return {
        type: PAGE_MEDIA_FOCUS,
        payload: media,
    };
};

export const uploadMediaAction = (media) => {
    return {
        type: PAGE_MEDIA_UPLOADING,
        payload: media,
    };
};

export const uploadMediaFailedAction = (media) => {
    return {
        type: PAGE_MEDIA_FAILED,
        payload: media,
    };
};

export const uploadMediaSucceedAction = (media) => {
    return {
        type: PAGE_MEDIA_UPLOADED,
        payload: media,
    };
};

export const deleteMediaAction = () => {
    return {
        type: PAGE_MEDIA_DELETING,
    };
};

export const pageMediaDeletedAction = (mediaId) => {
    return {
        type: PAGE_MEDIA_DELETED,
        payload: mediaId,
    };
};

export function resetPages() {
    return function (dispatch) {
        dispatch(pagesResetAction());
    };
}

export function resetPage() {
    return function (dispatch) {
        dispatch(pageResetAction());
    };
}

export function getPages(app, lang) {
    return function (dispatch) {
        dispatch(pagesPendingAction());
        return APIService
            .getPages(app.id, cookies.get('token'), lang)
            .then(pages => {
                dispatch(pagesDownloadedAction(pages, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, PAGES_FAILED));
            });
    };
}

export function fetchPage(appId, pageId, lang) {
    return function (dispatch, getState) {
        let pages = getState().pages.content[lang];
        if (pages !== undefined) {
            let page = pages.find(function (page) {
                return page.id === pageId;
            });
            if (page !== undefined && page) {
                return dispatch(pageFocusAction(page, lang));
            }
        }
        return dispatch(getPage(appId, pageId, lang));
    };
}

export function getPage(appId, pageId, lang) {
    return function (dispatch) {
        dispatch(pagesPendingAction());
        return APIService
            .getPage(appId, pageId, cookies.get('token'), lang)
            .then(page => {
                dispatch(pageDownloadedAction(page, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, PAGE_FAILED));
            });
    };
}

export function postPage(appId, page, lang) {
    return function (dispatch) {
        dispatch(postPageAction());
        return APIService
            .postPage(appId, page, cookies.get('token'), lang)
            .then(page => {
                dispatch(pageDownloadedAction(page, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, PAGE_FAILED));
            });
    };
}

export function putPage(appId, page, lang) {
    return function (dispatch) {
        dispatch(pageEditingAction());
        return APIService
            .putPage(appId, page, cookies.get('token'), lang)
            .then(page => {
                dispatch(pageDownloadedAction(page, lang));
            })
            .catch((
                error => {
                    dispatch(handleError(error, PAGE_FAILED));
                }
            ));
    };
}

export function deletePage(appId, pageId, lang) {
    return function (dispatch) {
        dispatch(deletePageAction());
        return APIService
            .deletePage(appId, pageId, cookies.get('token'), lang)
            .then(() => {
                dispatch(pageDeletedAction(pageId, lang));
            })
            .catch((error) => {
                dispatch(handleError(error, PAGE_FAILED));
            });

    };
}

// MEDIA

export function fetchPageMedia(appId, pageId, mediaId, lang) {
    return function (dispatch, getState) {
        return dispatch(getPageMedia(appId, pageId, mediaId, lang));
    };
}

export function getPageMedia(appId, pageId, mediaId, lang) {
    return function (dispatch) {
        dispatch(pagesPendingAction());
        return APIService
            .getPageMedia(appId, pageId, mediaId, cookies.get('token'), lang)
            .then(media => {
                dispatch(pageMediaFocusAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error, PAGES_FAILED));
            });
    };
}

export function deletePageMedia(appId, pageId, media, lang) {
    return function (dispatch) {
        dispatch(deleteMediaAction());
        return APIService
            .deletePageMedia(appId, pageId, media, cookies.get('token'), lang)
            .then(() => {
                dispatch(pageMediaDeletedAction(media.id));
            })
            .catch((error) => {
                dispatch(handleError(error, PAGE_FAILED));
            });
    };
}

export function postPageMedia(appId, pageId, media, lang, onUploadProgress = null) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        if (typeof media === 'string') {
            return APIService
                .postPageLinkMedia(
                    appId,
                    pageId,
                    media,
                    cookies.get('token'),
                    lang,
                )
                .then(page => {
                    dispatch(pageDownloadedAction(page, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        } else {
            return APIService
                .postPageMedia(appId, pageId, media, cookies.get('token'), lang, onUploadProgress)
                .then(page => {
                    dispatch(pageDownloadedAction(page, lang));
                    dispatch(uploadMediaSucceedAction(media));
                })
                .catch((error) => {
                    dispatch(handleError(error));
                    dispatch(uploadMediaFailedAction(media));
                });
        }
    };
}

export function putPageMedia(appId, pageId, media, lang) {
    return function (dispatch) {
        dispatch(uploadMediaAction(media));
        return APIService
            .putPageMedia(appId, pageId, media, cookies.get('token'), lang)
            .then(page => {
                dispatch(pageDownloadedAction(page, lang));
                dispatch(uploadMediaSucceedAction(media));
            })
            .catch((error) => {
                dispatch(handleError(error));
                dispatch(uploadMediaFailedAction(media));
            });
    };
}



// WEBPACK FOOTER //
// src/store/pages/actions.js